import { useTranslation } from "shared/localization/localization";
import { ArrowRightShortIcon } from "shared/ui/Icons";
import styles from "./BackButton.module.scss";

type BackButtonProps = {
  onClick?: () => void;
  showPreviousView?: () => void;
};

export const BackButton: RFC<BackButtonProps> = ({ onClick, showPreviousView }) => {
  const { t } = useTranslation();

  const goBack = () => {
    if (onClick) {
      onClick();
      return;
    }
    showPreviousView?.();
  };

  return (
    <button data-test-id="back-button" type="button" onClick={() => goBack()} className={styles.button}>
      <ArrowRightShortIcon className={styles.icon} />
      {t("Back")}
    </button>
  );
};
